// extracted by mini-css-extract-plugin
var _1 = "ra-notfound-artist";
var _2 = "ra-notfound";
var _3 = "ra-notfound-content";
var _4 = "ra-notfound-footer";
var _5 = "ra-notfound-left";
var _6 = "ra-notfound-review";
var _7 = "ra-notfound-right";
var _8 = "ra-notfound-subtitle";
var _9 = "ra-notfound-title";
export { _1 as "notFoundArtistCls", _2 as "notFoundCls", _3 as "notFoundContentCls", _4 as "notFoundFooterCls", _5 as "notFoundLeftCls", _6 as "notFoundReviewCls", _7 as "notFoundRightCls", _8 as "notFoundSubtitleCls", _9 as "notFoundTitleCls" }
